import React, { useEffect, useState } from 'react'
import { useCommonStyles } from '../../../utils';
import { useDispatch } from 'react-redux';
import usePageLoader from '../../../Redux/hooks/usePageLoader';
import useSnackBar from '../../../Redux/hooks/useSnackBar';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import StyledTableRow from '../../Common/StyledTableRow';
import StyledTableCell from '../../Common/StyledTableCell';
import ErrorHandler from '../../../lib/errorHandler';
import NoDataFound from '../../Common/NoDataFound';
import CommonPagination from '../../Common/CommonPagination';
import Assets from '../../Common/Assets';
import CommonTextField from '../../Common/CommonTextField';
import { getPerticularLotNumbers, getPOItem, updateLotNumber } from '../../../Redux/Actions/PurchaseEntry';
import { Box, Breadcrumbs, Button, Grid, Table, TableBody, TableContainer, TableHead, Typography, useTheme } from '@mui/material';
import CommonAutoComplete from '../../Common/CommonAutoComplete';
import CommonDatePicker from '../../Common/CommonDatePicker';
import dayjs from 'dayjs';
import { standardDateFormat } from '../../../lib/standardDateFormat';

const LotNumberTable = ({ isEditMode, setIsEditMode, setUniqueReelId, uniqueReelId, setIsOpenAddUpdateLotNumber, _getLotNumber }) => {
    // ============== Hooks ==============
    const theme = useTheme();
    const { classes } = useCommonStyles();
    const dispatch = useDispatch();
    const setFullPageLoader = usePageLoader();
    const { setSnackBar } = useSnackBar();

    // =============== States ===============
    const [page, setPage] = useState(1);
    const [reelByLotIdListData, setReelByLotIdListData] = useState([]);
    const [itemOptions, setItemOptions] = useState([]);

    // ============== Handler ==============
    const breadcrumbs = [
        <Typography color={theme.palette.bgBlack.main} sx={{ opacity: "70%", cursor: "pointer" }} fontFamily={'Satoshi-Medium'} onClick={() => clearData()}>
            Purchase Entry
        </Typography>,
        <Typography color={theme.palette.bgBlack.main} sx={{ opacity: "70%", cursor: "pointer" }} fontFamily={'Satoshi-Medium'} onClick={() => clearData()}>
            {`${isEditMode ? "Edit" : "Create New"} Lot Number`}
        </Typography>,
        <Typography color={theme.palette.bgBlack.main} fontFamily={'Satoshi-Medium'}>
            Lot Number Table
        </Typography>,
    ];

    // const tabelHeader = ["Type", "Item No.", reelByLotIdListData?.response?.[0]?.category == 1 ? "GSM / MIC" : reelByLotIdListData?.response?.[0]?.category == 2 ? "GSM / MIC" : reelByLotIdListData?.response?.[0]?.category == 3 ? "Chemical Code" : reelByLotIdListData?.response?.[0]?.category == 4 ? "Pantone number" : "GSM / MIC", "Lot No.", "Reel No.", "Size", "Weight"]
    const tabelHeader = [
        ...((reelByLotIdListData?.response?.[0]?.category !== 4 && reelByLotIdListData?.response?.[0]?.category !== 3) ? ["Type"] : []),
        ...((reelByLotIdListData?.response?.[0]?.category !== 4 && reelByLotIdListData?.response?.[0]?.category !== 3) ? ["Item No."] : []),
        "Item Name",
        ...(reelByLotIdListData?.response?.[0]?.category !== 4
            ? reelByLotIdListData?.response?.[0]?.category === 1 || reelByLotIdListData?.response?.[0]?.category === 2
                ? ["GSM / MIC"]
                : reelByLotIdListData?.response?.[0]?.category === 3
                    ? ["Chemical Code"]
                    : reelByLotIdListData?.response?.[0]?.category === 4
                        ? ["Pantone number"]
                        : ["GSM / MIC"]
            : []),

        "Lot No.",
        "Weight",
        ...(reelByLotIdListData?.response?.[0]?.category === 3 ? ["Chemical Serial No."] : reelByLotIdListData?.response?.[0]?.category === 4 ? ["Bucket No"] : ["Reel No."]),
        ...((reelByLotIdListData?.response?.[0]?.category === 3 || reelByLotIdListData?.response?.[0]?.category === 4) ? ["Batch No."] : []),
        ...((reelByLotIdListData?.response?.[0]?.category === 3 || reelByLotIdListData?.response?.[0]?.category === 4) ? ["Expire Date"] : []),
        ...((reelByLotIdListData?.response?.[0]?.category === 1 || reelByLotIdListData?.response?.[0]?.category === 2 || reelByLotIdListData?.response?.[0]?.category === 5) ? ["Size"] : []),
        // ...((reelByLotIdListData?.response?.[0]?.category === 1 || reelByLotIdListData?.response?.[0]?.category === 2 || reelByLotIdListData?.response?.[0]?.category === 5) ? ["Size Unit"] : []),

    ];

    let PerPage = 10

    const handleChangePage = (e, p) => {
        setPage(p);
        setReelByLotIdListData([])
    };

    const handleChangeForItems = (row, value, name) => {
        const updateItem = reelByLotIdListData?.response?.map((ele) => {
            if (ele?._id == row?._id) {
                if (name == "itemName") {
                    return {
                        ...ele,
                        [name]: value,
                        'GSMMIC': value?.GSMMIC
                    }
                } else {
                    return {
                        ...ele,
                        [name]: value,
                    }
                }
            } else {
                return {
                    ...ele
                }
            }
        })
        setReelByLotIdListData({ ...reelByLotIdListData, response: updateItem })
    }

    const clearData = () => {
        _getLotNumber();
        setIsOpenAddUpdateLotNumber(false);
        setUniqueReelId("");
        setIsEditMode(false)
    }


    // ============= get Inventories API =============
    const _getPerticularLotNumbers = async () => {
        setFullPageLoader(true);
        let response;
        let body = {
            "uniqueId": uniqueReelId,
            "limit": PerPage,
            "page": page
        }
        response = await dispatch(getPerticularLotNumbers(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data) {
                // setReelByLotIdListData(response?.payload?.data)
                _getPEItemByLotNumber(response?.payload?.data?.response?.[0]?.poNumber, response?.payload?.data?.response?.[0]?.category, response?.payload?.data)
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };
    // ============= get Inventories API =============
    const _getPEItemByLotNumber = async (poNumber, category, items) => {
        setFullPageLoader(true);
        let response;
        let body = {
            "poNumber": poNumber,
            "category": category,
        }
        response = await dispatch(getPOItem(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data) {
                if (response?.payload?.data?.response?.Items?.length > 0) {
                    if (response?.payload?.data?.response?.Items?.length == 1) {
                        const tempData = items?.response?.map((ele) => {
                            return {
                                ...ele,
                                itemName: { itemName: ele?.itemName ? ele?.itemName : response?.payload?.data?.response?.Items?.[0]?.itemName }
                            }
                        })
                        setReelByLotIdListData({ count: items?.count, response: tempData })
                    } else {
                        const tempData = items?.response?.map((ele) => {
                            return {
                                ...ele,
                                itemName: { itemName: ele?.itemName ? ele?.itemName : "" }
                            }
                        })
                        setReelByLotIdListData({ count: items?.count, response: tempData })
                        setItemOptions(response?.payload?.data?.response?.Items)
                    }
                }
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };
    // ============= add Inventory Field API =============
    const _updateLotNumber = async () => {
        setFullPageLoader(true);
        let response;
        const body = reelByLotIdListData?.response?.map((ele) => {
            return {
                "_id": ele?._id,
                "itemName": ele?.itemName?.itemName,
                "vendorName": ele?.vendorName,
                "poNumber": ele?.poNumber,
                "lotNumber": ele?.lotNumber,
                "companyName": ele?.companyName,
                "invoiceNumber": ele?.invoiceNumber,
                "invoiceDate": ele?.invoiceDate,
                "receiveDate": ele?.receiveDate,
                "totalWeight": ele?.totalWeight,
                "type": ele?.type,
                "externalItemNo": ele?.externalItemNo,
                "GSMMIC": ele?.GSMMIC,
                "reelNumber": ele?.reelNumber,
                "size": ele?.size,
                "sizeUnit": ele?.sizeUnit,
                "weight": ele?.weight,
                "batchNo": ele?.batchNo || "",
                "expiryDate": ele.expiryDate ? dayjs(ele.expiryDate).format("YYYY-MM-DD") : null,
            }
        })
        const finalBody = {
            datas: body
        }
        response = await dispatch(updateLotNumber(finalBody));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data) {
                setSnackBar("success", response?.payload?.message)
                setIsEditMode(!isEditMode)
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };

    // =============== Use Effects ===============
    useEffect(() => {
        if (uniqueReelId) {
            _getPerticularLotNumbers();
        }
    }, [page, uniqueReelId])


    return (
        <Grid container padding={"25px"} spacing={2}>
            <Grid item xs={12} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                <Box>
                    <Typography fontFamily={"Satoshi-Bold"} fontSize={"28px"}>{`${isEditMode ? "Edit" : "Create New"} Lot Number`}</Typography>
                    <Breadcrumbs
                        separator={<NavigateNextIcon fontSize="small" />}
                        aria-label="breadcrumb"
                    >
                        {breadcrumbs}
                    </Breadcrumbs>
                </Box>
                <Button className={classes.saveButton} startIcon={!isEditMode ? <Assets absolutePath={true} src={`/assets/img/WhiteEdit.svg`} /> : ""} onClick={isEditMode ? () => _updateLotNumber() : () => setIsEditMode(!isEditMode)}>{isEditMode ? "Save" : "Edit"}</Button>
            </Grid>
            <Grid item xs={12}>
                <Box sx={{ borderRadius: "26px", border: "1px solid", backgroundColor: theme.palette.bgWhite.main, borderColor: "#c8d3d96e", borderTop: "none" }}>
                    <TableContainer>
                        <Table sx={{ borderBottom: '1px solid #c8d3d96e' }}>
                            <TableHead>
                                <StyledTableRow isHeader style={{ backgroundColor: "#E9E9E9" }}>
                                    {tabelHeader?.map((ele) => {
                                        return (
                                            <StyledTableCell>{ele}</StyledTableCell>
                                        )
                                    })}
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {reelByLotIdListData?.response?.length > 0 ?
                                    reelByLotIdListData?.response?.map((row, index) => {
                                        return (
                                            <React.Fragment key={index}>
                                                <StyledTableRow>
                                                    {(reelByLotIdListData?.response?.[0]?.category !== 4 && reelByLotIdListData?.response?.[0]?.category !== 3) &&
                                                        <StyledTableCell>
                                                            {isEditMode ?
                                                                <CommonTextField
                                                                    width={"120px"}
                                                                    type="text"
                                                                    name="type"
                                                                    value={row?.type}
                                                                    // disabled
                                                                    placeholder="Ex. 10"
                                                                    sx={{ "&.MuiFormControl-root": { width: "fit-content" } }}
                                                                    onChange={(e) => handleChangeForItems(row, e.target.value, "type")}
                                                                />
                                                                :
                                                                row.type ? row.type : "NA"
                                                            }
                                                        </StyledTableCell>
                                                    }
                                                    {(reelByLotIdListData?.response?.[0]?.category !== 4 && reelByLotIdListData?.response?.[0]?.category !== 3) &&
                                                        <StyledTableCell>
                                                            {isEditMode ?
                                                                <CommonTextField
                                                                    width={"120px"}
                                                                    type="text"
                                                                    name="externalItemNo"
                                                                    value={row?.externalItemNo}
                                                                    placeholder="Ex. 10"
                                                                    sx={{ "&.MuiFormControl-root": { width: "fit-content" } }}
                                                                    onChange={(e) => handleChangeForItems(row, e.target.value, "externalItemNo")}
                                                                />
                                                                :
                                                                row.externalItemNo ? row.externalItemNo : "NA"
                                                            }
                                                        </StyledTableCell>
                                                    }
                                                    <StyledTableCell>
                                                        {isEditMode ?
                                                            <CommonAutoComplete
                                                                width={"180px"}
                                                                // label="Item Name"
                                                                placeholder="Item Name"
                                                                disabled={itemOptions?.length == 0}
                                                                options={itemOptions || []}
                                                                getOptionLabel={(option) => option?.itemName}
                                                                value={row?.itemName || null}
                                                                onChange={(e, newValue) => handleChangeForItems(row, newValue, "itemName")}
                                                            />
                                                            :
                                                            row.itemName?.itemName ? row.itemName?.itemName : "NA"
                                                        }
                                                    </StyledTableCell>
                                                    {(reelByLotIdListData?.response?.[0]?.category !== 4) &&
                                                        <StyledTableCell>
                                                            {isEditMode ?
                                                                <CommonTextField
                                                                    width={"120px"}
                                                                    type="text"
                                                                    name="GSMMIC"
                                                                    disabled
                                                                    value={row?.GSMMIC}
                                                                    placeholder="Ex. 10"
                                                                    sx={{ "&.MuiFormControl-root": { width: "fit-content" } }}
                                                                    onChange={(e) => handleChangeForItems(row, e.target.value, "GSMMIC")}
                                                                />
                                                                :
                                                                row.GSMMIC ? row.GSMMIC : "NA"
                                                            }
                                                        </StyledTableCell>
                                                    }
                                                    <StyledTableCell>
                                                        {isEditMode ?
                                                            <CommonTextField
                                                                width={"120px"}
                                                                type="text"
                                                                name="lotNumber"
                                                                disabled
                                                                value={row?.lotNumber}
                                                                placeholder="Ex. 10"
                                                                sx={{ "&.MuiFormControl-root": { width: "fit-content" } }}
                                                                onChange={(e) => handleChangeForItems(row, e.target.value, "lotNumber")}
                                                            />
                                                            :
                                                            row.lotNumber ? row.lotNumber : "NA"
                                                        }
                                                    </StyledTableCell>
                                                    <StyledTableCell>
                                                        {isEditMode ?
                                                            <CommonTextField
                                                                width={"120px"}
                                                                type="number"
                                                                name="weight"
                                                                value={row?.weight}
                                                                placeholder="Ex. 10"
                                                                sx={{ "&.MuiFormControl-root": { width: "fit-content" } }}
                                                                onChange={(e) => {
                                                                    if (+e?.target?.value >= 0) {
                                                                        handleChangeForItems(row, e.target.value, "weight")
                                                                    } else {
                                                                        return;
                                                                    }
                                                                }}
                                                            />
                                                            :
                                                            row.weight ? row.weight : "NA"
                                                        }
                                                    </StyledTableCell>
                                                    <StyledTableCell>
                                                        {isEditMode ?
                                                            <CommonTextField
                                                                width={"120px"}
                                                                type="text"
                                                                disabled
                                                                name="reelNumber"
                                                                value={row?.reelNumber}
                                                                placeholder="Ex. 10"
                                                                sx={{ "&.MuiFormControl-root": { width: "fit-content" } }}
                                                                onChange={(e) => handleChangeForItems(row, e.target.value, "reelNumber")}
                                                            />
                                                            :
                                                            row?.reelNumber ? row.reelNumber : "NA"
                                                        }
                                                    </StyledTableCell>
                                                    {(reelByLotIdListData?.response?.[0]?.category === 3 || reelByLotIdListData?.response?.[0]?.category === 4) &&
                                                        <StyledTableCell>
                                                            {
                                                                isEditMode ?
                                                                    <CommonTextField
                                                                        width={"120px"}
                                                                        type="text"
                                                                        name="size"
                                                                        value={row?.batchNo}
                                                                        placeholder="Batch No"
                                                                        sx={{ "&.MuiFormControl-root": { width: "fit-content" } }}
                                                                        onChange={(e) => handleChangeForItems(row, e.target.value, "batchNo")}
                                                                    />
                                                                    :
                                                                    row?.batchNo ? row.batchNo : "NA"
                                                            }
                                                        </StyledTableCell>
                                                    }
                                                    {(reelByLotIdListData?.response?.[0]?.category === 3 || reelByLotIdListData?.response?.[0]?.category === 4) &&
                                                        <StyledTableCell>
                                                            {
                                                                isEditMode ?
                                                                    <CommonDatePicker
                                                                        width={"120px"}
                                                                        value={row?.expiryDate || null}
                                                                        onChange={(value) => handleChangeForItems(row, value, "expiryDate")}
                                                                        name={"expiryDate"}
                                                                    />
                                                                    :
                                                                    row?.expiryDate ? standardDateFormat(row.expiryDate) : "NA"
                                                            }
                                                        </StyledTableCell>
                                                    }

                                                    {(reelByLotIdListData?.response?.[0]?.category === 1 || reelByLotIdListData?.response?.[0]?.category === 2 || reelByLotIdListData?.response?.[0]?.category === 5) &&
                                                        <StyledTableCell>
                                                            {isEditMode ?
                                                                <CommonTextField
                                                                    width={"120px"}
                                                                    type="number"
                                                                    name="size"
                                                                    value={row?.size}
                                                                    placeholder="Ex. 10"
                                                                    sx={{ "&.MuiFormControl-root": { width: "fit-content" } }}
                                                                    onChange={(e) => {
                                                                        if (+e?.target?.value >= 0) {
                                                                            handleChangeForItems(row, e.target.value, "size")
                                                                        } else {
                                                                            return;
                                                                        }
                                                                    }}
                                                                />
                                                                :
                                                                row.size ? row.size : "NA"
                                                            }
                                                        </StyledTableCell>
                                                    }
                                                    {/* {(reelByLotIdListData?.response?.[0]?.category === 1 || reelByLotIdListData?.response?.[0]?.category === 2 || reelByLotIdListData?.response?.[0]?.category === 5) &&
                                                        <StyledTableCell>
                                                            {isEditMode ?
                                                                <CommonTextField
                                                                    width={"120px"}
                                                                    type="text"
                                                                    // disabled
                                                                    name="sizeUnit"
                                                                    value={row?.sizeUnit}
                                                                    placeholder="Ex. mm"
                                                                    sx={{ "&.MuiFormControl-root": { width: "fit-content" } }}
                                                                    onChange={(e) => handleChangeForItems(row, e.target.value, "sizeUnit")}
                                                                />
                                                                :
                                                                row.sizeUnit ? row.sizeUnit : "NA"
                                                            }
                                                        </StyledTableCell>
                                                    } */}

                                                </StyledTableRow>
                                            </React.Fragment>
                                        )
                                    })
                                    :
                                    <StyledTableRow>
                                        <StyledTableCell colSpan={12}>
                                            <NoDataFound />
                                        </StyledTableCell>
                                    </StyledTableRow>
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <CommonPagination
                        totalCount={reelByLotIdListData?.count}
                        count={Math.ceil(reelByLotIdListData?.count / PerPage)}
                        itemsPerPage={PerPage}
                        page={page}
                        onChange={handleChangePage}
                    />
                </Box>
            </Grid >
        </Grid >
    )
}

export default LotNumberTable